// extracted by mini-css-extract-plugin
export default {"tooltipMessage":"RoleForm-module__tooltipMessage___sH0iv","note":"RoleForm-module__note___qGbEQ","banner":"RoleForm-module__banner___eG7gw"};